import { getLinkId } from '../../../common/services/tools';
import { getPersonLastName } from '../../../footdata/people/utils';

/**
 * Build the clickable player tags from the article's linked person references
 * (footdataPersonIds = array of IRIs/ids). Resolves each person from
 * store.person.detail (already loaded when the article form rendered its
 * PersonInputCollection) and keeps its shortLastName (fallback lastName).
 * Deduplicated by label; persons not yet loaded are skipped.
 *
 * @returns {Array<{ id: string, label: string }>}
 */
export function selectPlayers(personDetail, relatedPersonIds) {
  const ids = relatedPersonIds || [];
  const seen = new Set();
  const out = [];
  ids.forEach(ref => {
    const person = personDetail[getLinkId(ref)];
    if (!person) {
      return;
    }
    const label = getPersonLastName(person);
    if (!label || seen.has(label)) {
      return;
    }
    seen.add(label);
    out.push({ id: person.id || getLinkId(ref), label });
  });
  return out;
}
